<template>
    <div class="text-container not-found">
      <div class="text-inner">
        <img class="logo-broken" width="165px"
        src="../assets/images/KZ-Logo-Broken.svg" alt="Broken KitingZone logo">
        <h1>404 - Page not found</h1>
        <p>
          It seems like the page you're looking for doesn't exist...
        </p>
        <router-link to="/">
          <btn class="btn-small btn-white">
            Take me home
          </btn>
        </router-link>
     </div>
    </div>
</template>

<script>
import btn from './Btn';

export default {
  components: {
    btn,
  },
};
</script>

<style>

.not-found p {
  text-align: center;
  margin-top: -0.25em;
}

.not-found .text-inner {
  align-items: center;
}

.logo-broken {
  margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue